import { render, staticRenderFns } from "./AvSkeletonInput.vue?vue&type=template&id=27ca8fd7"
import script from "./AvSkeletonInput.vue?vue&type=script&lang=ts"
export * from "./AvSkeletonInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports